import { configureStore } from '@reduxjs/toolkit';
import productsReducer from './slices/productsSlice';
import uiReducer from './slices/uiSlice';
import userReducer from './slices/userSlice';
export const store = configureStore({
  reducer: {
    products: productsReducer,
    ui: uiReducer,
    user: userReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        // Ignore these action types (Firestore timestamp serialization issues)
        ignoredActions: ['feedback/submitFeedback/fulfilled', 'feedback/fetchFeedback/fulfilled'],
        // Ignore these paths in the state
        ignoredPaths: ['feedback.items']
      },    }),
});
export default store;